import { COLORS } from '@btime/constants'
import React from 'react'

import { useIsPermalinkPage } from '../../utils/session/permalinkToken'
import { useOpenPlaceModal } from '../../utils/routes/modals/modalsActions'
import FlexGrid from '../../components/structure/FlexGrid'
import Icon from '../../components/shapes/Icon'
import Link from '../../components/actions/Link'
import Text, { SmallText } from '../../packages/kiti/components/presentation/Text'

const getResumeSize = size => {
  switch (size) {
    case 'small':
      return 'xxsmall'
    case 'xsmall':
      return 'xxsmall'
    default:
      return 'xsmall'
  }
}

const PlacePresenter = ({ place, size, hideIcon, fontSize, isPublicPresenter = false, ...props }) => {
  const openModal = useOpenPlaceModal()
  const isPermaLink = useIsPermalinkPage()

  const isPublic = isPermaLink || isPublicPresenter

  if (!place) return false

  const resumeSize = getResumeSize(fontSize || size)

  return (
    <Link block onClick={!isPublic ? () => openModal(place) : undefined} underlineOnHover>
      <FlexGrid justify="flex-start" gutter={0.15}>
        <Text size={fontSize || size} {...props}>
          {place.name}
        </Text>
        {!hideIcon && !isPublic && <Icon name="BsSearch" color={COLORS.dark3} size="0.8rem" />}
      </FlexGrid>
      <SmallText {...props} size={resumeSize} color={COLORS.dark3}>
        {place.resume}
      </SmallText>
    </Link>
  )
}

export default PlacePresenter
